export const GET_FILTER_WHERE_EAT_REQUEST = "GET_FILTER_WHERE_EAT_REQUEST";
export const GET_FILTER_WHERE_EAT_SUCCESS = "GET_FILTER_WHERE_EAT_SUCCESS";
export const GET_FILTER_WHERE_EAT_FAILURE = "GET_FILTER_WHERE_EAT_FAILURE";
